import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import Modal from "./Modal";
import { MODAL_CLOSE } from "src/constants/images";
import { replaceFloatValue } from "utils/replaceFloatValue";

const SkillPriceBreakDownModal = ({
  isVisible,
  onCancel,
  onConfirm,
  amount,
  setUpgradeModal,
}) => {
  const handleConfirm = () => {
    onCancel();
    onConfirm();
  };

  const handleCancel = () => {
    {
      onCancel();
      setUpgradeModal(true);
    }
  };
  const addSkill = (index) => {
    if (!amount?.breakdown?.[0].length) return;
    let total = 0;
    const copiedData = [...amount.breakdown];

    for (let i = 0; i <= index; i++) {
      total = total + copiedData[i][0];
    }

    return total;
  };

  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="buying-modal card p-4"
    >
      <div className="header">
        <span
          onClick={() => onCancel()}
          onKeyPress={(e) => e.code == "Enter" && onCancel()}
          className="close-modal"
        >
          <img src={MODAL_CLOSE.SOURCE} alt="close" />
        </span>
        <h4 className="mb-1">Preview</h4>
        <p className="text mt-2">
          Total Price: {amount?.totalCost?.toFixed(4)} $GBET
        </p>
        <div className="mt-3">
          {amount?.breakdown?.map((item, index) => (
            <p className="text my-2" key={index}>
              {/* <strong>{item[1] / item[0]} $GBET/stat</strong> for {index == 0 ? 0 : addSkill(index) - item[0]} to {item[0]} -  <strong>{item[1]} $GBET</strong>. */}
              <strong>{(item[1] / item[0])?.toFixed(2)} $GBET/stat</strong> for{" "}
              {item[0]} stats - <strong>{item[1]?.toFixed(2)} $GBET</strong>.
            </p>
          ))}
        </div>

        <div className="body d-flex justify-content-center pt-4 mx-3 mb-0">
          <div className="position-relative">
            <button
              className="btn btn-primary continue mx-2"
              onClick={handleConfirm}
            >
              Confirm
            </button>
          </div>
          <div className="position-relative">
            <button
              className="btn btn-link-secondary cancel mx-2"
              onClick={() => handleCancel()}
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SkillPriceBreakDownModal;
